import React from 'react'
import Container from '@material-ui/core/Container'
import { Box, makeStyles, Typography } from '@material-ui/core'
import photo1 from "../../../assets/slider1.png";

const useStyles = makeStyles(theme => ({
    backImg: {
        backgroundImage: `url(${photo1})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        height: "100%",
    },
    container: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    text_slider_container: {
        width: "507px",
        height: "251px",
        backgroundColor: "rgba(226, 243, 236, 0.7)",
    },
    text: {
        padding: "40px",
    },
    title: {
        color: "#272727",
        fontSize: "36px",
        fontWeight: "bold"
    },
    subtitle: {
        color: "#272727",
        fontSize: "18px",
        fontWeight: 300
    }
}));

const Photo1 = () => {

    const classes = useStyles();

    return (
        <Box className={classes.backImg} component="div">
            <Container className={classes.container} >
                <Box className={classes.text_slider_container} component="div">
                    <Box className={classes.text} component="div">
                        <Typography className={classes.title} variant="h6">Velas que se sienten tan bien como se ven</Typography>
                        <Typography className={classes.subtitle} variant="body1">Expertos en la fabricación de velas desde 1979</Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export default Photo1
